import React from 'react';

import { Heading } from '../../../../components/Heading/Heading';
import { Text } from '../../../../components/Text/Text';
import { ADVERTISE_EMAIL } from '../../../../constants/constants';

import styles from './AdvertiseBottomSection.module.css';

export const AdvertiseBottomSection = () => {
  return (
    <div className="grid grid-cols-1 grid-rows-1" data-testid="AdvertiseBottomSection">
      {/* Background */}
      <div className="col-start-1 row-start-1 grid size-full grid-cols-1 grid-rows-1">
        <div
          className={`mb-px size-full bg-cover bg-center bg-no-repeat ${styles.bottomBackground}`}
          role="img"
          title="bottomWaveBackground"
        />
      </div>

      {/* Content */}
      <div className="py-lg col-start-1 row-start-1 grid h-full grid-cols-1 grid-rows-1 sm:mt-0 sm:pl-11 md:pl-14 lg:px-16 xl:container xl:mx-auto">
        <div className="col-start-1 col-end-5 self-center sm:col-end-7">
          <Heading variant="lg" className="mb-3 text-center md:mb-10">
            Begin your adventure with Fishbrain
          </Heading>
          <Text variant="lg" className="mb-0 text-center">
            Contact sales at
          </Text>
          <Text variant="lg" className="text-center font-semibold">
            {ADVERTISE_EMAIL}
          </Text>
        </div>
      </div>
    </div>
  );
};
